import { supabase } from "./api"

export async function completeAuthRedirect() {
  const url = new URL(window.location.href)

  // Handle PKCE flow (code parameter)
  const code = url.searchParams.get("code")
  if (code) {
    await supabase.auth.exchangeCodeForSession(code)
    url.searchParams.delete("code")
    url.searchParams.delete("type")
    history.replaceState({}, document.title, url.pathname + url.search)
    return
  }

  // Handle token-based flow (email change, password reset, etc.)
  const token = url.searchParams.get("token")
  const type = url.searchParams.get("type")

  if (token && type) {
    if (type === "email_change") {
      // For email change, we need to verify the OTP token
      const { data, error } = await supabase.auth.verifyOtp({
        token_hash: token,
        type: "email_change",
      })

      if (error) {
        logError("Error verifying email change:", error)
        sessionStorage.setItem("email_change_error", error.message)
      } else {
        debug("Email change verified successfully:", data)
        // Store confirmation status in sessionStorage
        // Note: With double_confirm_changes=true, data.user.email might still be the old email
        // until both confirmations are complete. We rely on pending_email_change for display.
        sessionStorage.setItem("email_change_step_confirmed", "true")
      }

      // Don't delete params here - let the confirmation page handle the display
      return
    }

    // Handle other token types if needed
  }

  // SECURITY FIX: Removed legacy hash-based token flow
  // Legacy flow exposed tokens in URL hash (#access_token=xxx&refresh_token=yyy)
  // This is insecure as tokens can be logged in browser history, server logs, etc.
  // Modern PKCE flow (handled above) is secure and recommended by Supabase
  // If you need to support legacy clients, re-enable with extreme caution
}
import { debug, error as logError } from "@/utils/debug"
